package features.overtime.domain

/**
 * Overtime request domain model
 * @param id Firestore document ID
 * @param userId User who requested overtime
 * @param date Date of overtime in YYYY-MM-DD format
 * @param startTime Start time in HH:mm format
 * @param endTime End time in HH:mm format
 * @param hours Calculated hours in "X.Xh" format
 * @param reason Reason for overtime request
 * @param status Status: "Pending", "Approved", or "Rejected"
 * @param createdAt Timestamp when request was created
 * @param reviewedAt Timestamp when request was reviewed (approved/rejected)
 * @param reviewedBy User ID of admin/owner who reviewed the request
 */
data class OvertimeRequest(
    val id: String,
    val userId: String,
    val date: String,
    val startTime: String,
    val endTime: String,
    val hours: String,
    val reason: String,
    val status: String,
    val createdAt: String,
    val reviewedAt: String? = null,
    val reviewedBy: String? = null
)
